export default __webpack_public_path__ + "static/media/eshop.3544451c.jpg";